// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"slider_navWrapper__mKXpu","sliderButton":"slider_sliderButton__3Fstn"};